<template>

  <div>
    <form>
      <div class="form-group">
        <label>{{ $t('Email') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="settings.email"
          maxlength="60">
        <ValidateMessage :error="validateErrors['settings.email']" />
      </div>
      <div class="form-group">
        <label>{{ $t('CNPJ') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="settings.cnpj"
          maxlength="18"
          placeholder="00.000.000/0000-00">
        <ValidateMessage :error="validateErrors['settings.cnpj']" />
      </div>
      <div
        class="form-group">
        <label>{{ $t('Token de acesso') }}</label>

        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="action"
            v-model="settings.action"
            id="radio1"
            value="filled_token">
          <label class="form-check-label" for="radio1">
            Já tenho o token, informar manualmente.
          </label>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="action"
            v-model="settings.action"
            id="radio2"
            value="request_token" />
          <label class="form-check-label" for="radio2">
            Não tenho o token. Solicitar token por e-mail.
          </label>
        </div>
      </div>
      <div
        class="form-group">
        <div v-if="settings.action === 'filled_token'">
          <input
            type="text"
            class="form-control"
            v-model="settings.access_token"
            maxlength="60"
            placeholder="Token" />
          <ValidateMessage :error="validateErrors['settings.access_token']" />
        </div>
        <div
          v-if="settings.action === 'request_token'"
          class="alert alert-info">
          Você receberá uma mensagem no e-mail solicitando o consentimento para criação da chave de acesso.<br><br>
          Após dar o consentimento, o campo "token de acesso" será preenchido.<br><br>
          Obs: Caso isso não aconteça, entre em contato conosco.
        </div>
      </div>
    </form>
  </div>

</template>

<script>
export default {
  name: 'CathoForm',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    },
    validateErrors: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      loading: false,
      settings: this.$clone(this.value || {}),
      requestTokenShow: false
    }
  },
  watch: {
    settings: {
      handler: function (newValue) {
        this.$emit('input', newValue)
      },
      deep: true
    }
  },
  created () {
    this.$set(this.settings, 'action', 'filled_token')
  },
  methods: {
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/CathoForm.vue